import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import type { FixturePartialUpsert } from "~pages/Fixtures/types";
import { transformFixtureListResponse } from "~pages/Fixtures/utilities";
import { useApi } from "~shared/api";
import { getFixtureListQueryKey } from "./useFetchAllSeasonFixtures";

export const useUpdateListFixture = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();

  return useMutation({
    mutationFn: async (upsertModel: FixturePartialUpsert) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/fixtures/${upsertModel.fixtureId}?include=seasons,entities,persons,venues,seasonStages,seasonPools,seasonSeries,seasonRounds`,
        method: "PUT",
        data: upsertModel.upsertData,
      });
    },
    onSuccess: (response: any) => {
      if (response?.data && response.data.length > 0) {
        const transformedFixtures = transformFixtureListResponse(response);
        const updatedFixture = transformedFixtures[0];

        queryClient.setQueryData(getFixtureListQueryKey({ sport, organizationId, seasonId }), (oldFixtures: []) =>
          (oldFixtures || []).map((oldFixture: any) => (oldFixture.fixtureId === updatedFixture.fixtureId ? updatedFixture : oldFixture)),
        );
      }
    },
  });
};
